import { IContentTopographicCodesGrid } from '@/modules/configurationModule/detail/samples/topography/TopographicCodes.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import axios from 'axios'

class TopographicCodesConfigurationServices {
    async paginator(filterModel: CommonFilterModel, params: CommonParams): Promise<IResponseAgGrid<IContentTopographicCodesGrid>> {
        const response = await axios.put<IResponseAgGrid<IContentTopographicCodesGrid>>(`/configuration/topographicCodes`, filterModel, { params })
        return response.data
    }
    async patchSamplesTopographiesBatch(request: IContentTopographicCodesGrid[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/topographicCodes/batch`, request)
        return response.data
    }
    async createSampleTopographies(request: IContentTopographicCodesGrid): Promise<IContentTopographicCodesGrid> {
        const response = await axios.post<IContentTopographicCodesGrid>(`/configuration/topographicCodes`, request)
        return response.data
    }
    async deleteSampleTopographiesBatch(request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/topographicCodes/batch`, { data: request })
        return response.data
    }
}

export const topographicCodesConfigurationServices = new TopographicCodesConfigurationServices()
